import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import {
  FETCH_EXTERNAL_APIS_REQUEST,
  FETCH_EXTERNAL_APIS_SUCCESS,
  FETCH_EXTERNAL_APIS_ERROR,
  UPDATE_EXTERNAL_API_REQUEST,
  UPDATE_EXTERNAL_API_SUCCESS,
  UPDATE_EXTERNAL_API_ERROR,
  TOGGLE_EXTERNAL_API_TARGET_REQUEST,
  TOGGLE_EXTERNAL_API_TARGET_SUCCESS,
  TOGGLE_EXTERNAL_API_TARGET_ERROR,
  RESET_EXTERNAL_APIS,
  GET_PAGES,
} from 'actionTypes'

export const mapApiToFrontend = (item = {}) => ({
  id: typeof item.id === 'object' ? item.id && item.id.id : item.id,
  name: item.name || '',
  group: item.vaultKey || '',
  description: item.description || '',
  urlDev: item.devUrl || '',
  urlPrd: item.prdUrl || '',
  usesVault: Boolean(item.fromVault),
  activeTarget: item.activeTarget || 'DEV',
  apiKeyDev: item.apiKeyDev || '',
  apiKeyPrd: item.apiKeyPrd || '',
  devUpdatedAt: item.devUpdatedAt,
  prdUpdatedAt: item.prdUpdatedAt,
})

export const mapFrontendToApi = (item = {}) => {
  const payload = {
    id: item.id,
    description: item.description,
    devUrl: item.urlDev,
    prdUrl: item.urlPrd,
  }

  if (!item.usesVault) {
    payload.apiKeyDev = item.apiKeyDev
    payload.apiKeyPrd = item.apiKeyPrd
  }

  return payload
}

const getPages = (metadata = {}) => ({
  type: GET_PAGES,
  pages: metadata.pageCount || 0,
  current: metadata.page || 1,
  count: metadata.totalCount || 0,
})

export const fetchExternalApisRequest = () => ({
  type: FETCH_EXTERNAL_APIS_REQUEST,
})

export const fetchExternalApisSuccess = (data, filter) => ({
  type: FETCH_EXTERNAL_APIS_SUCCESS,
  payload: data,
  filter,
})

export const fetchExternalApisError = (error) => ({
  type: FETCH_EXTERNAL_APIS_ERROR,
  payload: error,
})

export const fetchExternalApis =
  (token, filters = {}, page = 1) =>
  (dispatch) => {
    dispatch(fetchExternalApisRequest())

    const params = {
      ...filters,
      hasPagination: true,
      page,
      size: filters.size || 10,
    }

    return new Api(token, dispatch)
      .post(API_URL.EXTERNAL_APIS_FIND, params)
      .then(dispatch(showSpinner()))
      .then(
        (response) => {
          const data = (response.data && response.data.resultList) || []
          const mapped = data.map(mapApiToFrontend)
          dispatch(getPages(response.data && response.data.pages))
          dispatch(fetchExternalApisSuccess(mapped, params))
        },
        (error) => {
          dispatch(fetchExternalApisError(error))
        }
      )
      .finally(() => dispatch(hideSpinner()))
  }

export const updateExternalApiRequest = () => ({
  type: UPDATE_EXTERNAL_API_REQUEST,
})

export const updateExternalApiSuccess = (data) => ({
  type: UPDATE_EXTERNAL_API_SUCCESS,
  payload: data,
})

export const updateExternalApiError = (error) => ({
  type: UPDATE_EXTERNAL_API_ERROR,
  payload: error,
})

export const updateExternalApi = (token, values, onSuccess) => (dispatch) => {
  dispatch(updateExternalApiRequest())

  return new Api(token, dispatch)
    .post(API_URL.EXTERNAL_APIS_SAVE, mapFrontendToApi(values))
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateExternalApiSuccess(mapApiToFrontend(response.data)))
      if (onSuccess) {
        onSuccess()
      }
    })
    .catch((error) => {
      dispatch(updateExternalApiError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}

export const toggleExternalApiTargetRequest = (id) => ({
  type: TOGGLE_EXTERNAL_API_TARGET_REQUEST,
  id,
})

export const toggleExternalApiTargetSuccess = (id, data) => ({
  type: TOGGLE_EXTERNAL_API_TARGET_SUCCESS,
  id,
  payload: data,
})

export const toggleExternalApiTargetError = (id, error) => ({
  type: TOGGLE_EXTERNAL_API_TARGET_ERROR,
  id,
  payload: error,
})

export const toggleExternalApiTarget = (token, id, onSuccess) => (dispatch) => {
  dispatch(toggleExternalApiTargetRequest(id))

  return new Api(token, dispatch)
    .put(`${API_URL.EXTERNAL_APIS_TOGGLE_TARGET}/${id}/toggle-target`)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(toggleExternalApiTargetSuccess(id, mapApiToFrontend(response.data)))
      if (onSuccess) {
        onSuccess()
      }
    })
    .catch((error) => {
      dispatch(toggleExternalApiTargetError(id, error))
    })
    .finally(() => dispatch(hideSpinner()))
}

export const resetExternalApis = () => ({
  type: RESET_EXTERNAL_APIS,
})
